<template>
    <div v-if="show" class="modal show" role="modal">
        <div class="modal-backdrop show" style="z-index: unset" @mousedown="close"></div>
        <div class="modal-dialog modal-lg popup">
            <div class="modal-content">
                <div class="modal-header">
                    <div class="modal-title">
                        {{ trans('Planning') }}
                    </div>
                    <button type="button" class="close" @click="close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>

                <div class="modal-body">
                    <div v-if="!loading">
                        <div
                            v-if="showPermissionError"
                            class="alert text-center alert-danger mb-0"
                            role="alert"
                        >
                            {{ trans("You don't have rights for this project") }}
                        </div>
                        <task-detail-component
                            v-model="taskId"
                            :can-change-status="true"
                            :can-create-task="true"
                        ></task-detail-component>
                        <div
                            class="col-12 mt-3 text-center"
                            v-if="!taskId && errors && errors.taskId"
                        >
                            <p class="text-danger">
                                {{ trans('Select or create a task') }}
                            </p>
                        </div>

                        <div class="row">
                            <div class="col-12 col-lg-6">
                                <planning-form-time-component
                                    v-model="timings"
                                    :errors="errors ? errors : null"
                                    :fromSlot="fromSlot"
                                ></planning-form-time-component>
                            </div>
                            <div class="col-12 col-lg-6">
                                <planning-form-assignees-component
                                    v-model="assignees"
                                    :fromSlot="fromSlot"
                                    :planningDate="timings.dateStart"
                                ></planning-form-assignees-component>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="modal-footer">
                    <button
                        v-if="fromSlot"
                        @click="confirmDeleteSlot"
                        class="btn btn-danger font-weight-bold mr-auto">
                        {{ trans('delete') }}
                    </button>
                    <button @click="close" class="btn btn-secondary">
                        {{ trans('cancel') }}
                    </button>
                    <button class="btn btn-primary" @click="save" :disabled="loading">
                        {{ trans('save') }}
                    </button>
                </div>
            </div>
        </div>
        <update-repeated-slots-component
            v-if="updateRepeatedSlotsModal.active"
            :slot_id="updateRepeatedSlotsModal.slot_id"
            :all_update_option="updateRepeatedSlotsModal.all_update_option"
            @close="updateRepeatedSlotsModal.active = false"
            @update="handleRepeatedSlotsChoice"
        ></update-repeated-slots-component>

        <confirmation-modal-component
            v-if="showDeleteConfirmation"
            :subtitle="trans('Watch out')"
            :body="trans('Are you sure you want to delete this slot?')"
            @close="showDeleteConfirmation = false"
            @succes="deleteSlot"
        />
    </div>
</template>

<script>
import { emitter } from '../../plugins/Mitt';
import taskDetailComponent from '../person/time-sheet/TaskDetailComponent';
import planningFormAssigneesComponent from './planning-form-components/PlanningFormAssigneesComponent';
import planningFormTimeComponent from './planning-form-components/PlanningFormTimeComponent';
import { DateTimeFormatter, LocalDate } from '@js-joda/core';
import { mapActions, mapState } from 'vuex';
import UpdateRepeatedSlotsComponent from '../schedule/widgets/UpdateRepeatedSlotsComponent.vue';
import axios from "axios";
import confirmationModalComponent from "../helpers/ConfirmationModalComponent.vue";

const dateformatter = DateTimeFormatter.ofPattern('yyyy-MM-dd');
const today = LocalDate.now();
const todayFormatted = today.format(dateformatter);

function initialFormState(defaultLinkedAssignees, defaultLinkedDates) {
    return {
        taskId: null,
        timings: {
            dateStart: todayFormatted,
            dateEnd: todayFormatted,
            timeStart: '08:00',
            timeEnd: '16:00',
            isSpecificTime: 0,
            linkedDates: defaultLinkedDates,

            // Repeat timings
            isRepeatable: 0,
            repeatRangeType: 1,
            repeatUntil: todayFormatted,
            repeatAfter: 1,
            repeatFrequency: 1,
            repeatEvery: 1,
            repeatEveryType: 1,
            repeatOn: [],
            repeatOnEveryMonth: 1,
        },
        assignees: {
            assignedTeams: {},
            assignedPersons: [],
            assignedEquipments: [],
            linkedAssignees: defaultLinkedAssignees,
        },
        // The values passed by the event. The object is overwritten
        eventValues: {
            // All possible values
            slotId: null,
            personId: null,
            equipmentId: null,
            teamId: null,
            taskId: null,
            startDate: null,
            endDate: null,
            startTime: null,
            endTime: null,
        },
        errors: null,
    };
}
export default {
    components: {
        taskDetailComponent,
        planningFormAssigneesComponent,
        planningFormTimeComponent,
        UpdateRepeatedSlotsComponent,
        confirmationModalComponent,
    },
    data() {
        return {
            ...initialFormState(
                this.link_assets !== undefined ? this.link_assets : true,
                this.link_dates !== undefined ? this.link_dates : true
            ),
            show: false,
            loading: true,
            updateRepeatedSlotsModal: {
                active: false,
                slot_id: null,
                all_update_option: false,
                mode: 'save',
            },
            optionConfirmedRepeatedSlotsInModal: false,
            updateRepeatedSlotSetting: '',
            isRepeatableSlot: false,

            // Permissions
            showPermissionError: false,

            showDeleteConfirmation: false,
        };
    },
    computed: {
        ...mapState('planning', ['mode', 'teams', 'link_assets', 'link_dates', 'defaultWeekschedule']),
        fromSlot() {
            return !!this.eventValues.slotId;
        },
    },
    methods: {
        ...mapActions('planning', ['requestItemSlots', 'requestTaskIndex']),
        close() {
            this.show = false;
            this.updateRepeatedSlotsModal.active = false;
            // Reset with the current store values
            Object.assign(this.$data, initialFormState(
                this.link_assets !== undefined ? this.link_assets : true,
                this.link_dates !== undefined ? this.link_dates : true
            ));
        },
        handleEventValues() {
            this.errors = null; // Clear previous errors
            // Clicked on slot (editing existing)
            if (!!this.eventValues.slotId) {
                const slotId = this.eventValues.slotId;
                this.getSlotInfo(slotId); // This will set linkedAssignees = true for editing
            } 
            // Creating a new slot
            else {
                // Set default timings and other fields for a new slot
                this.taskId = this.eventValues.taskId ?? null;
                this.timings.dateStart = this.eventValues.dateStart || todayFormatted;
                this.timings.dateEnd = this.eventValues.dateEnd || todayFormatted;

                // Get day schedule from default week schedule
                const daySchedule = this.defaultWeekschedule[this.timings.dateStart];

                // Set times with proper fallback order: eventValues -> weekSchedule -> defaults
                this.timings.timeStart = this.eventValues.timeStart || 
                    daySchedule?.time_start || 
                    '08:00';
                this.timings.timeEnd = this.eventValues.timeEnd || 
                    daySchedule?.time_end || 
                    '16:00';

                this.timings.isSpecificTime = this.eventValues.isSpecificTime || 0;
                // Ensure isRepeatable and its related fields are reset for new slots
                this.timings.isRepeatable = 0;
                this.timings.repeatRangeType = 1;
                this.timings.repeatUntil = todayFormatted;
                this.timings.repeatAfter = 1;
                this.timings.repeatFrequency = 1;
                this.timings.repeatEvery = 1;
                this.timings.repeatEveryType = 1;
                this.timings.repeatOn = [];
                this.timings.repeatOnEveryMonth = 1;
                this.isRepeatableSlot = false; // Not an existing repeatable slot
                // Set linkedDates from the Vuex store for new slots
                this.timings.linkedDates = this.link_dates !== undefined ? this.link_dates : true;

                // Assignees for new slot
                this.assignees.assignedTeams = {};
                this.assignees.assignedPersons = this.eventValues.personId ? [this.eventValues.personId] : [];
                this.assignees.assignedEquipments = this.eventValues.equipmentId ? [this.eventValues.equipmentId] : [];
                
                // Set linkedAssignees from the Vuex store for new slots
                this.assignees.linkedAssignees = this.link_assets !== undefined ? this.link_assets : true;

                if (this.eventValues.teamId) {
                    const teamId = this.eventValues.teamId;
                    // Initialize with empty team structure
                    // The actual team members will be populated when teams are loaded with the correct date
                    this.assignees.assignedTeams[teamId] = {
                        persons: {},
                        equipments: {},
                    };
                }

                this.loading = false;
            }
        },
        getSlotInfo(slotId) {
            const url = route('planning.get-slot-data-for-planning-form', slotId);
            axios.get(url).then((response) => {
                // Task
                this.taskId = response.data.task_id;
                // Timings
                this.timings.dateStart = response.data.date_start;
                this.timings.dateEnd = response.data.date_end;
                this.timings.timeStart = response.data.time_start;
                this.timings.timeEnd = response.data.time_end;
                this.timings.isSpecificTime = response.data.is_specific_time;
                // When editing an existing slot, force linkedDates to true for the form
                this.timings.linkedDates = true;
                // Timings repeat
                if (response.data.repeatable_slot) {
                    this.timings.isRepeatable = true;
                    this.timings.repeatRangeType = response.data.repeatable_slot.range_type;
                    this.timings.repeatUntil = response.data.repeatable_slot.repeated_until;
                    this.timings.repeatAfter = response.data.repeatable_slot.repeated_after;
                    this.timings.repeatFrequency = response.data.repeatable_slot.repeated_frequency;
                    this.timings.repeatEvery = response.data.repeatable_slot.repeated_every;
                    this.timings.repeatEveryType =
                        response.data.repeatable_slot.repeated_every_type;
                    this.timings.repeatOn = response.data.repeatable_slot.repeated_every_on;
                    this.timings.repeatOnEveryMonth =
                        response.data.repeatable_slot.repeated_on_every_month;
                    this.isRepeatableSlot = true;
                }

                // Assignees
                this.assignees.assignedTeams = response.data.assigned_teams;
                this.assignees.assignedPersons = response.data.assigned_persons;
                this.assignees.assignedEquipments = response.data.assigned_equipments;

                // When editing an existing slot, force linkedAssignees to true for the form
                this.assignees.linkedAssignees = true;

                // Loading
                this.loading = false;
            });
        },
        save() {
            if (
                this.eventValues?.slotId &&
                this.timings.isRepeatable &&
                this.isRepeatableSlot &&
                !this.optionConfirmedRepeatedSlotsInModal
            ) {
                this.updateRepeatedSlotsModal.slot_id = this.eventValues.slotId;
                this.updateRepeatedSlotsModal.all_update_option = false;
                this.updateRepeatedSlotsModal.mode = 'save';
                this.updateRepeatedSlotsModal.active = true;
                return;
            }
            this.loading = true;
            this.showPermissionError = false;

            const url = route('planning.schedule-slots', this.eventValues?.slotId);
            axios
                .post(url, {
                    taskId: this.taskId,
                    timings: this.timings,
                    assignees: this.assignees,
                    updateRepeatedSlotSetting: this.updateRepeatedSlotSetting,
                })
                .then((response) => {
                    const payload = Object.assign({}, response.data || {}, { taskIds: [this.taskId].filter(Boolean) });
                    emitter.emit('planning-slots-changed', payload);
                    this.close();
                    this.loading = false;
                })
                .catch((err) => {
                    this.loading = false;
                    this.errors = err.response.data.errors;

                    if (err.response.status === 403) {
                        this.showPermissionError = true;
                    }
                    this.updateRepeatedSlotsModal.active = false;
                });
            if (this.optionConfirmedRepeatedSlotsInModal) {
                this.optionConfirmedRepeatedSlotsInModal = false;
                this.updateRepeatedSlotSetting = null;
            }
        },
        handleRepeatedSlotsChoice(value) {
            if (this.updateRepeatedSlotsModal.mode === 'delete') {
                this.updateRepeatedSlotsModal.active = false;
                this.deleteSlotWithOption(value);
                return;
            }
            this.updateRepeatedSlotSetting = value;
            this.optionConfirmedRepeatedSlotsInModal = true;
            this.save();
        },
        confirmDeleteSlot(){
            if( !this.fromSlot ){
                return;
            }
            if (this.isRepeatableSlot) {
                this.updateRepeatedSlotsModal.slot_id = this.eventValues.slotId;
                this.updateRepeatedSlotsModal.all_update_option = false;
                this.updateRepeatedSlotsModal.mode = 'delete';
                this.updateRepeatedSlotsModal.active = true;
                return;
            }
            this.showDeleteConfirmation = true;
        },
        deleteSlot(){
            this.showDeleteConfirmation = false;
            if( !this.fromSlot ){
                return;
            }
            const url = route('planning.delete-slots', this.eventValues.slotId);

            axios.delete(url)
                .then((response) => {
                    emitter.emit('planning-slots-changed', response.data);
                    this.close();
                });
        },
        deleteSlotWithOption(value){
            if( !this.fromSlot ){
                return;
            }
            const url = route('planning.delete-slots', this.eventValues.slotId);

            axios.delete(url, { params: { updateRepeatedSlotSetting: value } })
                .then((response) => {
                    emitter.emit('planning-slots-changed', response.data);
                    this.close();
                });
        }
    },
    mounted() {
        emitter.on('open-planning-form', (eventValues) => {
            emitter.emit('hide-slot-hover-info');
            emitter.emit('hide-day-hover-info');
            emitter.emit('hide-context-menu-component');

            this.loading = true;
            this.eventValues = eventValues;
            this.handleEventValues();
            this.show = true;
        });

        emitter.on('new-task-created', ({ taskId }) => {
            if (this.mode == 'project') {
                this.requestTaskIndex({ taskId: taskId });
            }
        });
        emitter.on('task-updated-planning', ({ taskId }) => {
            const taskIds = [taskId];
            this.requestItemSlots({ itemsIds: taskIds, fromRefreshContextMenu: true });
        });
    },
};
</script>
